webpackJsonp([1,2],{

/***/ 270:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(88)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(42),
  /* template */
  __webpack_require__(277),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 271:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(93)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(43),
  /* template */
  __webpack_require__(282),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 272:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(87)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(44),
  /* template */
  __webpack_require__(276),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 273:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(90)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(45),
  /* template */
  __webpack_require__(279),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 274:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(89)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(46),
  /* template */
  __webpack_require__(278),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 275:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(92)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(47),
  /* template */
  __webpack_require__(281),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 276:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.readLocalFileShow),
      expression: "readLocalFileShow"
    }],
    staticClass: "read-local-file"
  }, [_c('div', {
    staticClass: "info-wraper"
  }, [(!_vm.isMobile) ? _c('h3', [_vm._v("拖拽 .md 扩展名文件到此处加载")]) : _vm._e(), _c('label', {
    staticClass: "add-icon",
    attrs: {
      "title": "打开一个markdown文件"
    }
  }, [_vm._v("+"), _c('input', {
    ref: "fileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.openFile
    }
  })])]), _c('a', {
    staticClass: "cancel-import",
    on: {
      "click": _vm.cancelImport
    }
  }, [_vm._v("×")])])])
},staticRenderFns: []}

/***/ }),

/***/ 277:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "markdown-header"
  }, [_c('a', {
    staticClass: "catalog-btn",
    on: {
      "click": _vm.toggleCatalog
    }
  }), _c('a', {
    staticClass: "made-by",
    attrs: {
      "href": "https://lfyfly.github.io/fly-markdown/",
      "target": "_blank",
      "title": "制作软件地址"
    }
  }, [_vm._v("made by flyMarkdown")]), _c('div', {
    staticClass: "document-header",
    class: {
      noFileInfo: _vm.IsNoFileInfo
    }
  }, [_c('h1', {
    staticClass: "document-title"
  }, [_vm._v(_vm._s(_vm.editingFile ? _vm.editingFile.fileName : 'fly-markdown'))]), (!_vm.editingFile) ? _c('a', {
    staticClass: "title-icon iconfont icon-github",
    attrs: {
      "href": "https://github.com/lfyfly/fly-markdown",
      "title": "github",
      "target": "_blank"
    }
  }) : _vm._e()]), (_vm.editingFile === null || (_vm.editingFile !== null && _vm.editingFile.info.length != 0)) ? _c('div', {
    staticClass: "document-info"
  }, _vm._l((_vm.fileInfo), function(v) {
    return _c('div', {
      staticClass: "info"
    }, [_c('span', {
      staticClass: "info-key"
    }, [_vm._v(_vm._s(v.key + ': '))]), _c('span', {
      staticClass: "info-value"
    }, [_c('a', {
      attrs: {
        "href": _vm._f("addHttp")(v),
        "title": _vm._f("addHttp")(v),
        "target": v.link ? '_blank' : false
      }
    }, [_vm._v(_vm._s(v.value))])])])
  })) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 278:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide2bottom"
    }
  }, [(_vm.type === 'create' ? _vm.createShow : _vm.reviseShow) ? _c('div', {
    staticClass: "new-markdown"
  }, [_c('div', {
    staticClass: "dialog"
  }, [_c('div', {
    staticClass: "dialog-title"
  }, [_c('h4', [_vm._v(_vm._s(_vm.typeObject[_vm.type].dialogTile))])]), _c('div', {
    staticClass: "dialog-content"
  }, [_vm._l((_vm.fileInfoArr), function(v, i) {
    return _c('div', {
      staticClass: "input"
    }, [(i === 0) ? _c('span', {
      staticClass: "key"
    }, [_vm._v(_vm._s(v.key))]) : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (v.key),
        expression: "v.key"
      }],
      staticClass: "key",
      attrs: {
        "spellcheck": "false"
      },
      domProps: {
        "value": _vm._s(v.key)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          v.key = $event.target.value
        }
      }
    }), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (v.value),
        expression: "v.value"
      }],
      staticClass: "value",
      attrs: {
        "spellcheck": "false"
      },
      domProps: {
        "value": _vm._s(v.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          v.value = $event.target.value
        }
      }
    }), (i != 0) ? _c('div', {
      staticClass: "addlink"
    }, [_c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [_c('input', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.linkInputShow[i]),
        expression: "linkInputShow[i]"
      }, {
        name: "model",
        rawName: "v-model",
        value: (v.link),
        expression: "v.link"
      }],
      staticClass: "link",
      attrs: {
        "spellcheck": "false",
        "type": "url",
        "placeholder": "请输入绑定链接"
      },
      domProps: {
        "value": _vm._s(v.link)
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          v.link = $event.target.value
        }
      }
    })]), _c('a', {
      staticClass: "iconfont icon-iconfontlink",
      on: {
        "click": function($event) {
          _vm.addLink(i)
        }
      }
    })], 1) : _vm._e(), (i === 0) ? [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.fileNameIsEmpty),
        expression: "fileNameIsEmpty"
      }],
      staticClass: "fileName-tip"
    }, [_vm._v("必填")]), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.hadRepeatFile),
        expression: "hadRepeatFile"
      }],
      staticClass: "fileName-tip"
    }, [_vm._v("重名")])] : _vm._e()], 2)
  }), _c('div', {
    staticClass: "tip"
  }, [_vm._v("第二个第三个key值可以自定义")])], 2), _c('div', {
    staticClass: "dialog-btns"
  }, [_c('a', {
    staticClass: "create",
    on: {
      "click": _vm.sureFn
    }
  }, [_vm._v(_vm._s(_vm.typeObject[_vm.type].sureBtn))]), _c('a', {
    staticClass: "cancel",
    on: {
      "click": _vm.cancelFn
    }
  }, [_vm._v(_vm._s(_vm.typeObject[_vm.type].cancelBtn))])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 279:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "markdown2html"
  }, [_c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.catalogShow),
      expression: "catalogShow"
    }],
    ref: "catalog",
    staticClass: "markdown-catalog"
  }, _vm._l((_vm.catalogArr), function(v1) {
    return _c('ul', [_c('li', [_c('a', {
      staticClass: "title level1",
      attrs: {
        "href": '#' + v1.title
      }
    }, [_vm._v(_vm._s(v1.title))])]), _vm._l((v1.children), function(v2) {
      return (v1.children && _vm.catalogLevel >= 2) ? _c('ul', [_c('li', [_c('a', {
        staticClass: "title level2",
        attrs: {
          "href": '#' + v2.title
        }
      }, [_vm._v(_vm._s(v2.title))])]), _vm._l((v2.children), function(v3) {
        return (v2.children && _vm.catalogLevel >= 3) ? _c('ul', [_c('li', [_c('a', {
          staticClass: "title level3",
          attrs: {
            "href": '#' + v3.title
          }
        }, [_vm._v(_vm._s(v3.title))])])]) : _vm._e()
      })], 2) : _vm._e()
    })], 2)
  }))]), _c('div', {
    staticClass: "med-line"
  }), _c('div', {
    ref: "markdownHtml",
    staticClass: "markdown-html",
    domProps: {
      "innerHTML": _vm._s(_vm.markdownHtml)
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 280:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('markdown-header'), _c('markdown2html'), _c('markdown-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.markdownStr),
      expression: "markdownStr"
    }],
    ref: "markdownInput",
    domProps: {
      "value": (_vm.markdownStr)
    },
    on: {
      "flod": _vm.textareaFold,
      "input": function($event) {
        _vm.markdownStr = $event
      }
    }
  }), _c('new-markdown', {
    attrs: {
      "type": "create"
    }
  }), _c('new-markdown', {
    attrs: {
      "type": "revise"
    }
  }), _c('rename', {
    attrs: {
      "renameFileList": _vm.renameFileList
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 281:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.renameShow) ? _c('div', {
    staticClass: "rename-cover"
  }, [_c('div', {
    staticClass: "rename"
  }, [_c('h3', {
    staticClass: "rename-title"
  }, [_vm._v("重名文件处理")]), _c('div', {
    staticClass: "rename-item-container"
  }, _vm._l((_vm.optionArr), function(v, i) {
    return _c('div', {
      staticClass: "rename-item",
      on: {
        "click": function($event) {
          _vm.enterRenameState($event, i)
        }
      }
    }, [_c('input', {
      staticClass: "file-name-input",
      class: {
        'repeat-error': v.error, 'correct': !v.error
      },
      attrs: {
        "spellcheck": "false",
        "disabled": v.selected === '重命名' ? false : true
      },
      domProps: {
        "value": v.rename
      },
      on: {
        "input": function($event) {
          _vm.checkName($event, i)
        },
        "click": function($event) {
          _vm.enterRenameState($event, i)
        }
      }
    }), _c('select', {
      domProps: {
        "value": v.selected
      },
      on: {
        "change": function($event) {
          _vm.selectChange($event, i)
        }
      }
    }, _vm._l((_vm.optionList), function(v1) {
      return _c('option', [_vm._v(_vm._s(v1))])
    }))])
  })), _c('div', {
    staticClass: "batch-operation"
  }, [_c('a', {
    staticClass: "all-replace",
    class: {
      active: _vm.allReplace
    },
    on: {
      "click": _vm.setAllReplace
    }
  }, [_vm._v("全部覆盖")]), _c('a', {
    staticClass: "all-cancel",
    class: {
      active: _vm.allCancel
    },
    on: {
      "click": _vm.setAllCancel
    }
  }, [_vm._v("全部抛弃")])]), _c('div', {
    staticClass: "btns"
  }, [_c('a', {
    staticClass: "sure",
    on: {
      "click": _vm.rename
    }
  }, [_vm._v("确定")])]), (_vm.passAllErrorShow) ? _c('div', {
    staticClass: "passAll-error"
  }, [_vm._v("验证未全部通过")]) : _vm._e()])]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 282:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "markdown-input"
    }
  }, [_c('read-local-file'), _c('div', {
    directives: [{
      name: "drag",
      rawName: "v-drag",
      value: ({
        moveElId: 'markdown-input',
        dragOutX: 30,
        dragOutY: 30,
        cursor: 'move'
      }),
      expression: "{moveElId:'markdown-input', dragOutX:30, dragOutY:30, cursor:'move'}"
    }],
    staticClass: "markdown-option"
  }, [_c('div', {
    staticClass: "option-list"
  }, [_c('a', {
    staticClass: "iconfont",
    class: {
      active: !_vm.textareaShow, 'icon-web_shouhui': _vm.textareaShow, 'icon-web_xiangxiazhankai': !_vm.textareaShow
    },
    attrs: {
      "title": _vm.textareaShow ? '收起编辑区' : '展开编辑区'
    },
    on: {
      "click": _vm.toggleFoldTextarea
    }
  }), _c('a', {
    staticClass: "iconfont icon-daoru-copy",
    attrs: {
      "title": "导入本地markdown文件"
    },
    on: {
      "click": _vm.importFile
    }
  }), _c('a', {
    staticClass: "iconfont icon-daochu2",
    attrs: {
      "title": "导出markdown文件到本地"
    },
    on: {
      "click": function($event) {
        _vm.exportFileSure('markdown')
      }
    }
  }), _c('a', {
    staticClass: "iconfont icon-html",
    attrs: {
      "title": "导出html文件到本地"
    },
    on: {
      "click": function($event) {
        _vm.exportFileSure('html')
      }
    }
  }), _c('a', {
    staticClass: "iconfont icon-baocun",
    attrs: {
      "title": "保存"
    },
    on: {
      "click": _vm.save
    }
  }), _c('a', {
    staticClass: "iconfont icon-iconfontxinjian",
    class: {
      active: !_vm.editingFile
    },
    attrs: {
      "title": "新建"
    },
    on: {
      "click": _vm.newMarkdown
    }
  }), _c('a', {
    staticClass: "iconfont",
    class: {
      active: _vm.fileListShow, 'icon-shouqi': _vm.fileListShow, 'icon-zhankai1': !_vm.fileListShow
    },
    attrs: {
      "title": _vm.fileListShow ? '收起目录' : '展开目录'
    },
    on: {
      "click": _vm.toggleFileListShow
    }
  })])]), _c('textarea', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.textareaShow),
      expression: "textareaShow"
    }],
    ref: "textarea",
    attrs: {
      "spellcheck": "false"
    },
    on: {
      "keydown": [function($event) {
        if (_vm._k($event.keyCode, "tab", 9)) { return; }
        $event.preventDefault();
      }, function($event) {
        if (_vm._k($event.keyCode, "enter", 13)) { return; }
        _vm.save($event)
      }],
      "input": _vm.input2markdownData
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipShowState),
      expression: "tipShowState"
    }],
    staticClass: "tip",
    class: [_vm.tipShowStyle],
    domProps: {
      "textContent": _vm._s(_vm.tipShowContent)
    }
  }), (!_vm.editingFile) ? _c('div', {
    staticClass: "cover"
  }, [_c('pre', {
    staticClass: "edit-tip"
  }, [_vm._v("请先创建文件\n或者从文件列表加载一个文件\n再开始编辑\n")])]) : _vm._e(), _c('transition', {
    attrs: {
      "name": "fileListSlide"
    }
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fileListShow),
      expression: "fileListShow"
    }],
    staticClass: "fileList"
  }, _vm._l((_vm.fileList), function(v) {
    return _c('li', {
      class: {
        showIcon: _vm.isMobile
      },
      on: {
        "click": _vm.readFile
      }
    }, [_c('a', {
      staticClass: "fileList-fileName",
      class: {
        editActive: _vm.editingFile && _vm.editingFile.fileName === v
      }
    }, [_vm._v(_vm._s(v))]), _c('span', {
      staticClass: "del"
    }, [_c('a', {
      staticClass: "iconfont icon-shanchu del-file",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.del($event)
        }
      }
    })]), _c('div', {
      staticClass: "sure-del",
      staticStyle: {
        "display": "none"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [_c('a', {
      staticClass: "sure",
      attrs: {
        "title": "确认删除"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.sureDel($event)
        }
      }
    }, [_vm._v("×")]), _c('a', {
      staticClass: "cancel",
      attrs: {
        "title": "取消删除"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.cancelDel($event)
        }
      }
    }, [_vm._v(">")])]), _c('span', {
      staticClass: "revise",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.reviseInfo($event)
        }
      }
    }, [_c('a', {
      staticClass: "iconfont icon-weibiaoti-- revise-info"
    })])])
  }))])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 286:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_dragdrag__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_dragdrag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_dragdrag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_icon_font_iconfont_css__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_icon_font_iconfont_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__static_icon_font_iconfont_css__);






__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_vue_dragdrag___default.a);




new __WEBPACK_IMPORTED_MODULE_0_vue___default.a({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 3:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__js_vue_log_js__ = __webpack_require__(49);






var RE = function RE(observerData) {
  return JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(observerData));
};


/* harmony default export */ __webpack_exports__["a"] = new __WEBPACK_IMPORTED_MODULE_2_vue___default.a({
  name: 'bus.js',
  data: {

    isMobile: false,
    winWidth: NaN,
    catalogShow: false,
    textareaShow: true,
    fileListShow: false,
    createShow: false,
    reviseShow: false,
    renameShow: false,
    readLocalFileShow: false,
    tipShow: { content: '', state: 'false', style: '', timer: null },

    editingFile: null,
    markdownData: '',
    reviseingInfo: null,
    fileList: [],

    renameFileList: [],

    LoadFileList: []

  },
  computed: {},
  methods: {
    init: function init() {
      this.initIsMobile();
      this.initFileList();
      this.initWinWidth();

      window.addEventListener('resize', this.resizeInitWinWidth);
    },
    initIsMobile: function initIsMobile() {
      if (navigator.userAgent.match(/(iPhone|iPod|iPad|Android|ios)/i)) this.isMobile = true;
    },
    initWinWidth: function initWinWidth() {
      this.winWidth = window.innerWidth;
    },
    resizeInitWinWidth: function resizeInitWinWidth() {
      this.initWinWidth();
    },
    initFileList: function initFileList() {
      this.fileList = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(localStorage).filter(function (v, i) {
        return v.indexOf('$Data$') === -1;
      });
    },
    getFileInfo: function getFileInfo(fileName) {
      var infoStr = localStorage[fileName];
      var info = !infoStr ? [] : JSON.parse(infoStr);
      return { fileName: fileName, info: info };
    },
    saveInLocal: function saveInLocal(fileName, info, markdownData) {
      localStorage[fileName] = info ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(info) : '';
      localStorage[fileName + '$Data$'] = markdownData;
    },
    saveFiles2LocalStorage: function saveFiles2LocalStorage(fileArr) {
      var _this = this;

      fileArr.forEach(function (file) {
        var fileName = file.fileName.replace('.md', '');
        _this.saveInLocal(fileName, file.fileInfo, file.fileData);
      });
    },
    hadSameFile: function hadSameFile(fileName) {
      if (!fileName) return;

      if (this.fileList.length != 0 && this.fileList.indexOf(fileName) != -1) return true;
    },
    removeFileData: function removeFileData(fileName) {
      localStorage.removeItem(fileName);
      localStorage.removeItem(fileName + '$Data$');

      this.initFileList();

      if (this.editingFile && fileName === this.editingFile.fileName) {
        this.textareaShow = true;
        this.editingFile = null;
        this.markdownData = '';
      }
    },
    save: function save() {
      if (this.editingFile && this.editingFile.fileName) {
        localStorage[this.editingFile.fileName + '$Data$'] = this.markdownData;
      }
    },
    openAfile: function openAfile(fileName) {
      this.editingFile = this.getFileInfo(fileName);
      this.markdownData = localStorage[fileName + '$Data$'];
    },
    showTipFn: function showTipFn(_ref) {
      var _this2 = this;

      var content = _ref.content,
          _ref$timeOut = _ref.timeOut,
          timeOut = _ref$timeOut === undefined ? 2000 : _ref$timeOut,
          style = _ref.style,
          _ref$condition = _ref.condition,
          condition = _ref$condition === undefined ? 'withoutCondition' : _ref$condition;

      if (!condition) return;

      this.tipShow.content = content;
      this.tipShow.style = style;
      this.tipShow.state = true;

      if (this.tipShow.timer) clearTimeout(this.tipShow.timer);

      this.tipShow.state = true;

      this.tipShow.timer = setTimeout(function () {
        _this2.tipShow.state = false;
      }, timeOut);

      window.eLog('\u663E\u793Atip', this);

      return true;
    }
  },

  created: function created() {
    this.init();
  },

  watch: {
    renameFileList: function renameFileList(_renameFileList) {
      if (_renameFileList.length === 0) return;

      this.readLocalFileShow = false;
      this.renameShow = true;
    },
    LoadFileList: function LoadFileList(fileArr) {
      this.saveFiles2LocalStorage(fileArr);

      this.initFileList();

      if (this.LoadFileList.length === 1) {
        this.openAfile(this.LoadFileList[0].fileName);
      } else {
        this.fileListShow = true;
      }
    }
  }
});

/***/ }),

/***/ 38:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(91)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(41),
  /* template */
  __webpack_require__(280),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 41:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_bus_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_markdown2html_markdown2html_vue__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_markdown2html_markdown2html_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_markdown2html_markdown2html_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_markdown_header_markdown_header_vue__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_markdown_header_markdown_header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_markdown_header_markdown_header_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_markdown_input_markdown_input_vue__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_markdown_input_markdown_input_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_markdown_input_markdown_input_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_new_markdown_new_markdown_vue__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_new_markdown_new_markdown_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_new_markdown_new_markdown_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_rename_rename_vue__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_rename_rename_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_rename_rename_vue__);










/* harmony default export */ __webpack_exports__["default"] = {
  name: 'app',
  data: function data() {
    return {
      markdownStr: "",

      oldScrollHeight: 0,
      inputScrollEl: null,
      htmlScrollEl: null,
      oldScrollTop: 0,

      htmlContainerEl: null,
      markdownInputEl: null,

      phoneInputHeight: 110,

      padInputHeight: 210,

      autoSaveInterval: 3000
    };
  },

  computed: {
    renameFileList: function renameFileList() {
      return __WEBPACK_IMPORTED_MODULE_0__components_bus_js__["a" /* default */].renameFileList;
    }
  },
  methods: {
    init: function init() {
      this.getInputScrollEl();
      this.getHtmlScrollEl();

      this.getHtmlContainerEl();

      this.getMarkdownInputEl();
    },
    getInputScrollEl: function getInputScrollEl() {
      this.inputScrollEl = document.querySelector('textarea');
    },
    getHtmlScrollEl: function getHtmlScrollEl() {
      this.htmlScrollEl = document.querySelector('.markdown-html');
    },
    getHtmlContainerEl: function getHtmlContainerEl() {
      this.htmlContainerEl = document.querySelector('.markdown2html');
    },
    getMarkdownInputEl: function getMarkdownInputEl() {
      this.markdownInputEl = this.$refs.markdownInput.$el;
    },
    textareaFold: function textareaFold() {
      var _this = this;

      if (__WEBPACK_IMPORTED_MODULE_0__components_bus_js__["a" /* default */].isMobile || window.innerWidth <= 440) {
        this.$nextTick(function () {
          _this.htmlContainerEl.style.bottom = _this.markdownInputEl.offsetHeight + 'px';
        });
      } else {
        this.htmlContainerEl.removeAttribute('style');
      }
    },
    resposeScroll: function resposeScroll() {
      var _this2 = this;

      var inputScrollFn = function inputScrollFn(e) {
        if (e.target.scrollTop < _this2.oldScrollTop || _this2.oldScrollHeight === e.target.scrollHeight) return;
        _this2.oldScrollTop = e.target.scrollTop;
        _this2.oldScrollHeight = e.target.scrollHeight;
        console.log(e.target.scrollTop, e.target.scrollHeight, e.target.scrollHeight - e.target.scrollTop, e.target.offsetHeight);
        var whenScroll = e.target.scrollHeight - e.target.scrollTop;
        if (whenScroll > e.target.offsetHeight && whenScroll <= e.target.offsetHeight + 10) {
          _this2.htmlScrollEl.scrollTop = _this2.htmlScrollEl.scrollHeight;
        }
      };
      this.inputScrollEl.addEventListener('scroll', inputScrollFn);
    },
    mobileInput: function mobileInput() {
      if (__WEBPACK_IMPORTED_MODULE_0__components_bus_js__["a" /* default */].isMobile) {
        var oInput = document.querySelector('#markdown-input');
        var oTextarea = oInput.getElementsByTagName('textarea')[0];
        if (window.innerWidth <= 440) {
          var height = this.phoneInputHeight;
          oInput.style.bottom = '0';
        } else {
          this.htmlScrollEl.style.borderBottom = "none";
          var height = this.padInputHeight;
          oInput.style.left = '0';
          oInput.style.bottom = '0';
          oInput.style.top = 'auto';
          oInput.style.right = 'auto';
          oInput.style.width = '100%';
          oTextarea.style.width = '100%';
        }

        oTextarea.style.height = height - 30 + 'px';
        document.querySelector('.markdown2html').style.bottom = height + 'px';
      }
    }
  },
  mounted: function mounted() {
    this.init();
    this.mobileInput();
    this.resposeScroll();

    window.addEventListener('resize', this.textareaFold);
  },

  components: {
    markdownHeader: __WEBPACK_IMPORTED_MODULE_2__components_markdown_header_markdown_header_vue___default.a,
    markdown2html: __WEBPACK_IMPORTED_MODULE_1__components_markdown2html_markdown2html_vue___default.a,
    markdownInput: __WEBPACK_IMPORTED_MODULE_3__components_markdown_input_markdown_input_vue___default.a,
    newMarkdown: __WEBPACK_IMPORTED_MODULE_4__components_new_markdown_new_markdown_vue___default.a,
    rename: __WEBPACK_IMPORTED_MODULE_5__components_rename_rename_vue___default.a
  }
};

/***/ }),

/***/ 42:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bus_js__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = {
  name: 'markdown-header',
  data: function data() {
    return {
      msg: 'this is from markdown-header.vue'
    };
  },

  filters: {
    addHttp: function addHttp(v) {
      return v.link ? v.link.indexOf('http') === -1 ? 'http://' + v.link : v.link : false;
    }
  },
  computed: {
    winWidth: function winWidth() {
      return __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].winWidth;
    },
    editingFile: function editingFile() {
      return __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].editingFile;
    },
    fileInfo: function fileInfo() {
      return __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].editingFile && __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].editingFile.info.length > 0 ? __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].editingFile.info : __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].editingFile ? null : [{ key: '软件作者', value: 'lfyfly' }, { key: '邮箱', value: '410793635@qq.com' }];
    },
    catalogShow: function catalogShow() {
      return __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].catalogShow;
    },
    IsNoFileInfo: function IsNoFileInfo() {
      return Boolean(__WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].editingFile && !this.fileInfo);
    }
  },
  methods: {
    toggleCatalog: function toggleCatalog() {
      __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].catalogShow = !__WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].catalogShow;
    }
  }
};

/***/ }),

/***/ 43:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bus_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__html_template_min_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__read_local_file_read_local_file_vue__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__read_local_file_read_local_file_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__read_local_file_read_local_file_vue__);






var FileSaver = __webpack_require__(94);
/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    readLocalFile: __WEBPACK_IMPORTED_MODULE_2__read_local_file_read_local_file_vue___default.a
  },
  name: 'markdown-input',
  data: function data() {
    return {
      msg: 'this is from markdown-input.vue'
    };
  },

  computed: {
    isMobile: function isMobile() {
      return __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].isMobile;
    },
    winWidth: function winWidth() {
      return __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].winWidth;
    },
    textareaShow: function textareaShow() {
      return __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].textareaShow;
    },
    fileListShow: function fileListShow() {
      return __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].fileListShow;
    },
    editingFile: function editingFile() {
      return __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].editingFile;
    },
    fileList: function fileList() {
      return __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].fileList;
    },
    markdownData: function markdownData() {
      return __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].markdownData;
    },
    tipShowState: function tipShowState() {
      return __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].tipShow.state;
    },
    tipShowStyle: function tipShowStyle() {
      return __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].tipShow.style;
    },
    tipShowContent: function tipShowContent() {
      return __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].tipShow.content;
    }
  },
  methods: {
    toggleFoldTextarea: function toggleFoldTextarea() {
      if (this.nofileEditingTipFn()) return;

      __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].textareaShow = !__WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].textareaShow;

      this.$emit('flod');
    },
    importFile: function importFile() {
      var oldTextareaShow = __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].textareaShow;
      __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].textareaShow = true;
      if (!oldTextareaShow && !__WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].readLocalFileShow) return;

      __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].readLocalFileShow = !__WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].readLocalFileShow;
    },
    exportFileSure: function exportFileSure(fileType) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].save();

      if (this.nofileEditingTipFn()) return;

      var catalogShow = __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].catalogShow;
      if (!catalogShow) __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].catalogShow = true;
      this.$nextTick(function () {
        if (fileType === 'markdown') _this.exportMdFile();
        if (fileType === 'html') _this.exportHtmlFile();

        if (!catalogShow) __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].catalogShow = false;
      });
    },
    save: function save(e) {
      if (this.nofileEditingTipFn()) return;

      __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].save();

      if (e.type === 'keydown') return;

      __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].showTipFn({
        content: '文件保存成功',
        style: 'correct',
        condition: __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].editingFile
      });
    },
    newMarkdown: function newMarkdown() {
      __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].createShow = true;
    },
    toggleFileListShow: function toggleFileListShow() {
      __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].fileListShow = !__WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].fileListShow;
    },
    nofileEditingTipFn: function nofileEditingTipFn() {
      return __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].showTipFn({
        condition: !__WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].editingFile,
        content: '当前没有文件正在编辑',
        style: 'warn'
      });
    },
    input2markdownData: function input2markdownData(event) {
      __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].markdownData = event.target.value;
    },
    readFile: function readFile(e) {
      __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].save();

      var fileName = e.target.textContent;
      if (__WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].editingFile && fileName === __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].editingFile.fileName) return;

      __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].openAfile(fileName);
    },
    del: function del(e) {
      e.target.parentNode.nextSibling.style.display = 'block';
    },
    sureDel: function sureDel(e) {
      var parentEl = e.target.parentNode;

      var fileName = parentEl.previousSibling.previousSibling.textContent;
      parentEl.style.display = 'none';
      if (e.target.title === '确认删除') {

        __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].removeFileData(fileName);

        __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].showTipFn({
          content: '\u6587\u4EF6 [' + fileName + '] \u5220\u9664\u6210\u529F',
          style: 'correct'
        });
      }
    },
    cancelDel: function cancelDel(e) {
      var parentEl = e.target.parentNode;
      parentEl.style.display = 'none';
    },
    reviseInfo: function reviseInfo(e) {
      var fileName = e.target.parentNode.parentNode.children[0].textContent;
      var fileInfo = __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].getFileInfo(fileName);

      fileInfo.oldFileName = fileInfo.fileName;

      __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].reviseingInfo = fileInfo;
    },
    exportHtmlFile: function exportHtmlFile() {
      var headerHtmlStr = document.querySelector('.markdown-header').outerHTML;
      var contenthtmlStr = document.querySelector('.markdown2html').innerHTML;

      contenthtmlStr = contenthtmlStr.replace(/class=\"markdown-catalog.*?\"/, 'class=\"markdown-catalog catalog-hide\"');

      contenthtmlStr = '<div class="markdown2html">' + contenthtmlStr + '</div>';

      var bodyHtml = headerHtmlStr + contenthtmlStr;
      var htmlFileStr = __WEBPACK_IMPORTED_MODULE_1__html_template_min_js__["a" /* default */].replace('这里注入html的位置', bodyHtml);

      var blob = new Blob([htmlFileStr], { type: "text/plain;charset=utf-8" });
      FileSaver.saveAs(blob, __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].editingFile.fileName + ".html");
    },
    exportMdFile: function exportMdFile() {

      var infoWrite2File = '';
      if (__WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].editingFile.info.length > 0) {
        __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].editingFile.info.forEach(function (v) {
          var value = '[' + v.value + ']';
          if (v.link) {
            var link = v.link;
            if (v.link.indexOf('http://') === -1) {
              link = 'http://' + v.link;
            }
            value = '[' + v.value + '](' + link + ')';
          }

          infoWrite2File += '> **' + v.key + '**: ' + value + '\n\n';
        });
      }
      infoWrite2File = infoWrite2File === '' ? '' : '---\n\n' + infoWrite2File + '---\n\n';

      var blob = new Blob([infoWrite2File, __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].markdownData], { type: "text/plain;charset=utf-8" });
      FileSaver.saveAs(blob, __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].editingFile.fileName + ".md");
    },
    removeLeftAndTop: function removeLeftAndTop(newWinWidth, oldWinWidth) {
      if (newWinWidth <= 800) {
        this.$refs.textarea.removeAttribute('style');

        if (!__WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].textareaShow) this.$refs.textarea.style.display = 'none';

        if (oldWinWidth && oldWinWidth > 800 || newWinWidth <= 440 && oldWinWidth && oldWinWidth > 440) {
          this.$el.removeAttribute('style');
          this.$el.style.position = 'absolute';
        }
      }
    }
  },
  mounted: function mounted() {
    this.$watch('winWidth', this.removeLeftAndTop);
  },

  watch: {
    markdownData: function markdownData(v) {
      this.$refs.textarea.value = v;
    }
  }
};

/***/ }),

/***/ 44:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bus_js__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["default"] = {
  name: 'read-local-file',
  data: function data() {
    return {
      msg: 'this is from read-local-file.vue'
    };
  },

  computed: {
    isMobile: function isMobile() {
      return __WEBPACK_IMPORTED_MODULE_1__bus_js__["a" /* default */].isMobile;
    },
    readLocalFileShow: function readLocalFileShow() {
      return __WEBPACK_IMPORTED_MODULE_1__bus_js__["a" /* default */].readLocalFileShow;
    }
  },
  methods: {
    openFile: function openFile(e) {
      var _this = this;

      var file = e.target.files[0];
      if (!file) return;

      if (!this.isMarkdownFile(file.name)) {
        __WEBPACK_IMPORTED_MODULE_1__bus_js__["a" /* default */].showTipFn({
          content: '请选择正确 .md 文件再打开',
          style: 'warn'
        });
        return;
      }

      this.readFile2Str(file).then(function (reslove) {
        if (__WEBPACK_IMPORTED_MODULE_1__bus_js__["a" /* default */].hadSameFile(reslove.fileName)) {
          __WEBPACK_IMPORTED_MODULE_1__bus_js__["a" /* default */].renameFileList = [reslove];
          _this.renameShow = true;
        } else {
          __WEBPACK_IMPORTED_MODULE_1__bus_js__["a" /* default */].saveInLocal(reslove.fileName, reslove.fileInfo, reslove.fileData);
          __WEBPACK_IMPORTED_MODULE_1__bus_js__["a" /* default */].readLocalFileShow = false;
          __WEBPACK_IMPORTED_MODULE_1__bus_js__["a" /* default */].openAfile(reslove.fileName);
        }
      });
    },
    cancelImport: function cancelImport() {
      __WEBPACK_IMPORTED_MODULE_1__bus_js__["a" /* default */].readLocalFileShow = false;
    },
    readFile2Str: function readFile2Str(file) {

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (reslove, reject) {
        var reader = new FileReader();
        reader.readAsText(file);
        reader.onload = function () {
          var fileContent = reader.result;

          var fileInfo = null;
          var fileData = fileContent;
          var fileInfoRes = fileContent.match(/^\-\-\-([\w\W]*)\-\-\-\n\n/);
          if (fileInfoRes) {
            var fileInfoStr = fileInfoRes[0];
            fileData = fileContent.replace(fileInfoStr, '');
          }

          if (fileInfoStr) {

            var keyPattern = /\*\*(.+)\*\*/g;
            var keyPattern1 = /\*\*(.+)\*\*/;
            var keys = fileInfoStr.match(keyPattern);

            var keysArr = keys.map(function (key) {
              return key.match(keyPattern1)[1];
            });

            var valuePattern = /\:\s(.+)\n\n/g;
            var valuePattern1 = /\:\s\[(.+)\](?:\((.+)\))?\n\n/;
            var values = fileInfoStr.match(valuePattern);

            var valuesArr = values.map(function (value) {
              var match = value.match(valuePattern1);

              return { value: match[1], link: match[2] ? match[2] : '' };
            });

            fileInfo = valuesArr.map(function (info, i) {
              info.key = keysArr[i];
              return info;
            });
          }

          reslove({ fileName: file.name.replace('.md', ''), fileInfo: fileInfo, fileData: fileData });
        };
      });
    },
    dragFn: function dragFn(event) {
      event.preventDefault();

      if (event.type === 'dragover' || event.type === 'dragenter') {
        return;
      }

      var hasReapetFile = false;

      var tasks = [];
      var repeatFilesTasks = [];
      if (event.type == "drop") {
        var files = event.dataTransfer.files;
        for (var i = 0; i < files.length; i++) {
          if (!this.isMarkdownFile(files[i].name)) {
            this.showTipFn();
            continue;
          }

          if (__WEBPACK_IMPORTED_MODULE_1__bus_js__["a" /* default */].hadSameFile(files[i].name.replace('.md', ''))) {
            repeatFilesTasks.push(this.readFile2Str(files[i]));
            continue;
          }

          tasks.push(this.readFile2Str(files[i]));
        }

        if (repeatFilesTasks.length > 0) {
          hasReapetFile = true;
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(repeatFilesTasks).then(function (reslove) {
            __WEBPACK_IMPORTED_MODULE_1__bus_js__["a" /* default */].renameFileList = reslove;
          });
        }

        if (tasks.length === 0) {

          return;
        }
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(tasks).then(function (reslove) {
          __WEBPACK_IMPORTED_MODULE_1__bus_js__["a" /* default */].LoadFileList = reslove;

          __WEBPACK_IMPORTED_MODULE_1__bus_js__["a" /* default */].readLocalFileShow = false;

          if (__WEBPACK_IMPORTED_MODULE_1__bus_js__["a" /* default */].LoadFileList.length > 1) __WEBPACK_IMPORTED_MODULE_1__bus_js__["a" /* default */].fileListShow = true;
        });
      }
    },
    getFileExtension: function getFileExtension(fileName) {
      return fileName.match(/\.([^.]+)$/)[1];
    },
    isMarkdownFile: function isMarkdownFile(fileName) {
      return this.getFileExtension(fileName) === 'md';
    }
  },
  mounted: function mounted() {

    this.$el.addEventListener("dragenter", this.dragFn);
    this.$el.addEventListener("dragover", this.dragFn);
    this.$el.addEventListener("drop", this.dragFn);
  }
};

/***/ }),

/***/ 45:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bus_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_highlight_js__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_highlight_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_highlight_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_marked__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_marked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_marked__);






/* harmony default export */ __webpack_exports__["default"] = {
  name: 'markdown2html',
  data: function data() {
    return {
      msg: 'this is from markdown2html.vue',
      titleElsArr: [],
      catalogArr: [],
      colorArr: ['red', 'green', 'blue']
    };
  },

  props: {
    catalogLevel: {
      type: Number,
      default: 3 },
    IgnoreCatalog: {
      type: Boolean,
      default: false },
    usehighLightCode: {
      type: Boolean,
      default: true }
  },
  computed: {
    winWidth: function winWidth() {
      return __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].winWidth;
    },
    catalogShow: function catalogShow() {
      return __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].catalogShow;
    },
    markdownData: function markdownData() {
      return __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].markdownData;
    },
    markdownHtml: function markdownHtml() {
      return __WEBPACK_IMPORTED_MODULE_2_marked___default()(this.ParsecolorTag(this.markdownData));
    }
  },
  created: function created() {
    this.initCatalogShow();
    this.$watch('winWidth', this.initCatalogShow);
  },

  methods: {
    initCatalogShow: function initCatalogShow() {
      __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].catalogShow = __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].winWidth > 800 ? true : false;
    },
    trim: function trim(str) {
      return str.replace(/^\s|\s$/g, '');
    },
    titleElsForEach: function titleElsForEach() {
      this.titleElsArr = [];
      var childrenEls = this.$refs.markdownHtml.children;
      for (var i = 0; i < childrenEls.length; i++) {
        this.filterTitle(childrenEls[i], i, childrenEls);

        if (this.setTableCaption(childrenEls[i], i, childrenEls)) i--;
      }
      this.addLinkBlank();
    },
    filterTitle: function filterTitle(el, i) {
      if (!el.tagName.toLowerCase().match(/^h\d*$/)) return;

      this.titleElsArr.push(el);

      var hmtlText = this.trim(el.textContent);

      el.removeAttribute('id');
      el.innerHTML = '<a class="title" href="#' + hmtlText + '" id="' + hmtlText + '">' + el.innerHTML + '</a>';
    },
    setTableCaption: function setTableCaption(el, i, children) {
      if (el.tagName.toLowerCase() === 'table' && i != 0 && children[i - 1].innerHTML.indexOf('T-T ') != -1) {
        var hmtlStr = children[i - 1].innerHTML;
        var captionStr = hmtlStr.replace('T-T ', '');
        var oCaption = document.createElement('caption');
        oCaption.innerHTML = captionStr;
        el.insertBefore(oCaption, el.children[0]);
        this.$refs.markdownHtml.removeChild(children[i - 1]);
        return true;
      }
    },
    getCatalogArr: function getCatalogArr(title) {
      var _this = this;

      this.catalogArr = [];

      if (this.titleElsArr.length === 0) return;

      var firstIndex = this.titleElsArr.length > 2 && this.IgnoreCatalog ? 1 : 0;

      var rootTitleIndex = parseInt(this.titleElsArr[firstIndex].tagName.substring(1));

      this.titleElsArr.forEach(function (v, i) {
        var tagName = v.tagName.toLowerCase();
        switch (tagName) {
          case 'h' + rootTitleIndex:
            _this.catalogArr.push({ title: v.textContent, level: 1 });
            break;
          case 'h' + (rootTitleIndex + 1):
            var level1 = _this.catalogArr[_this.catalogArr.length - 1];
            if (!level1.children) _this.$set(level1, 'children', []);
            level1.children.push({ title: v.textContent, level: 2 });
            break;

          case 'h' + (rootTitleIndex + 2):
            var level1 = _this.catalogArr[_this.catalogArr.length - 1];

            if (__WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].showTipFn({ content: '目录不要跨级别使用', timeout: 5000, style: 'warn', condition: !level1.children })) return;

            var level2 = level1.children[level1.children.length - 1];
            if (!level2.children) _this.$set(level2, 'children', []);
            level2.children.push({ title: v.textContent, level: 3 });
            break;
        }
      });
    },
    addLinkBlank: function addLinkBlank() {
      var links = this.$refs.markdownHtml.getElementsByTagName('a');
      for (var i = 0; i < links.length; i++) {
        if (!links[i].className) {
          links[i].className = 'link';
          links[i].target = '_blank';
          links[i].title = links[i].href;
          links[i].style.textDecoration = 'underline';
        }
      }
    },
    highLightCode: function highLightCode() {
      if (!this.usehighLightCode) return;

      var codeEls = document.querySelectorAll('code');
      if (codeEls.length === 0) return;
      for (var i = 0; i < codeEls.length; i++) {
        __WEBPACK_IMPORTED_MODULE_1_highlight_js___default.a.highlightBlock(codeEls[i]);
      }
    },
    ParsecolorTag: function ParsecolorTag(markdownStr) {
      var htmlStr = markdownStr;
      this.colorArr.forEach(function (color) {
        htmlStr = htmlStr.replace(new RegExp('\<' + color + '\>', "g"), '<font color="' + color + '">');
      });
      htmlStr = htmlStr.replace(/\<\/\>/g, '</font>');
      return htmlStr;
    }
  },

  watch: {
    markdownHtml: function markdownHtml() {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.highLightCode();

        _this2.titleElsForEach();

        if (!__WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].catalogShow) return;
        _this2.getCatalogArr();
      });
    },
    catalogShow: function catalogShow(_catalogShow) {
      if (!_catalogShow) return;
      this.getCatalogArr();
    }
  }
};

/***/ }),

/***/ 46:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bus_js__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = {
  name: 'new-markdown',
  data: function data() {
    return {
      msg: 'this is from new-markdown.vue',

      linkInputShow: [false, false, false],
      typeObject: {
        create: {
          dialogTile: '创建',
          sureBtn: '创建文件',
          cancelBtn: '取消'
        },

        revise: {
          dialogTile: '修改文件信息',
          sureBtn: '修改完成',
          cancelBtn: '取消修改'
        }

      },
      fileInfoArr: [{ key: '文件名', value: '', link: '' }, { key: '作者', value: '', link: '' }, { key: '联系方式', value: '', link: '' }],

      createInfo: null
    };
  },

  props: {
    type: {
      type: String }
  },
  computed: {
    reviseingInfo: function reviseingInfo() {
      return __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].reviseingInfo;
    },
    createShow: function createShow() {
      return __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].createShow;
    },
    reviseShow: function reviseShow() {
      return __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].reviseShow;
    },
    fileName: function fileName() {
      return this.fileInfoArr[0].value;
    },
    fileNameIsEmpty: function fileNameIsEmpty() {
      return this.fileName === '';
    },
    hadSameFile: function hadSameFile() {
      return __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].hadSameFile(this.fileName);
    },
    hadRepeatFile: function hadRepeatFile() {
      return !this.fileNameIsEmpty && this.hadSameFile && !(this.reviseingInfo && this.reviseingInfo.oldFileName === this.fileName);
    },
    passValidate: function passValidate() {
      return !this.fileNameIsEmpty && !this.hadRepeatFile;
    }
  },
  methods: {
    sureFn: function sureFn() {
      this.type === 'create' ? this.create() : this.revise();
    },
    cancelFn: function cancelFn() {
      this.type === 'create' ? this.cancelCreate() : this.cancelRevise();
    },
    getCreateInfo: function getCreateInfo() {
      if (!this.fileInfoArr[0].value) {
        alert('文件名不能为空');
        return;
      }

      if (this.passValidate) {
        var obj = {
          fileName: this.fileInfoArr[0].value,
          info: []
        };
        this.fileInfoArr.forEach(function (v, i) {
          if (i >= 1 && v.key && v.value) obj.info.push({ key: v.key, value: v.value, link: v.link });
        });

        this.createInfo = obj;
      }
    },
    create: function create() {
      __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].save();

      this.getCreateInfo();

      if (!this.createInfo) return;

      __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].saveInLocal(this.createInfo.fileName, this.createInfo.info, '');

      __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].initFileList();

      __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].createShow = false;

      __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].editingFile = this.createInfo;
      __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].markdownData = '';

      this.resetInfoValue();

      this.createInfo = null;
    },
    cancelCreate: function cancelCreate() {
      __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].createShow = false;
    },
    revise: function revise() {

      __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].save();

      this.getCreateInfo();

      if (!this.createInfo) return;

      var fileName = this.createInfo.fileName;
      var oldFileName = __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].reviseingInfo.oldFileName;
      var revisedFileInfo = this.createInfo.info;
      __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].saveInLocal(fileName, revisedFileInfo, localStorage[oldFileName + '$Data$']);
      if (__WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].reviseingInfo.oldFileName != fileName) __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].removeFileData(oldFileName);

      __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].initFileList();
      __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].reviseShow = false;

      __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].openAfile(fileName);

      this.resetInfoValue();
      this.createInfo = null;
      __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].reviseingInfo = null;
    },
    cancelRevise: function cancelRevise() {
      __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].reviseShow = false;
    },
    reviseInit: function reviseInit() {

      if (!this.reviseingInfo) return;

      this.fileInfoArr[0].value = this.reviseingInfo.fileName;
      if (this.reviseingInfo.info.length === 0) return;

      if (this.reviseingInfo.info.length <= 2) {
        this.fileInfoArr[1] = this.reviseingInfo.info[0];
      }
      if (this.reviseingInfo.info.length === 2) {
        this.fileInfoArr[2] = this.reviseingInfo.info[1];
      }
    },
    resetInfoValue: function resetInfoValue() {
      this.fileInfoArr.forEach(function (v) {
        v.value = '';
        v.link = '';
      });
    },
    addLink: function addLink(i) {
      this.$set(this.linkInputShow, i, !this.linkInputShow[i]);
    }
  },
  watch: {
    reviseingInfo: function reviseingInfo(v) {
      if (!v) return;
      this.reviseInit();
      __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].reviseShow = true;
    }
  }
};

/***/ }),

/***/ 47:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bus_js__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = {
  name: 'rename',
  data: function data() {
    return {
      msg: 'this is from rename.vue',
      optionList: ['重命名', '覆盖', '放弃加载'],

      optionArr: [],
      passAllErrorShow: false
    };
  },

  props: {
    renameFileList: {
      type: Array,
      default: function _default() {
        return ['文件1', '文件2', '文件2'];
      }
    }
  },
  computed: {
    renameShow: function renameShow() {
      return __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].renameShow;
    },
    passAll: function passAll() {
      return this.optionArr.every(function (v) {
        return !v.error;
      });
    },
    allReplace: function allReplace() {
      return this.optionArr.every(function (v) {
        return v.selected === '覆盖';
      });
    },
    allCancel: function allCancel() {
      return this.optionArr.every(function (v) {
        return v.selected === '放弃加载';
      });
    }
  },
  methods: {
    initOptionArr: function initOptionArr() {
      for (var i = 0; i < __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].renameFileList.length; i++) {
        this.optionArr.push({ rename: __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].renameFileList[i].fileName, error: true, selected: '重命名' });
      }
    },
    setAllReplace: function setAllReplace() {
      this.optionArr.forEach(function (v, i) {
        v.error = false;
        v.selected = '覆盖';
        v.rename = __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].renameFileList[i].fileName;
      });
    },
    setAllCancel: function setAllCancel() {
      this.optionArr.forEach(function (v, i) {
        v.error = false;
        v.selected = '放弃加载';
        v.rename = __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].renameFileList[i].fileName;
      });
    },
    selectChange: function selectChange(e, i) {
      var el = e.target;
      if (el.value === '重命名') {
        this.optionArr[i].error = true;

        return;
      }
      this.optionArr[i].selected = el.value;
      this.optionArr[i].error = false;
      this.optionArr[i].rename = __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].renameFileList[i].fileName;
    },
    enterRenameState: function enterRenameState(e, i) {
      if (e.target.tagName.toLowerCase() !== 'input') return;
      var el = e.target;
      if (this.optionArr[i].selected != '重命名') {
        this.optionArr[i].selected = '重命名';
        this.optionArr[i].error = true;
      }
    },
    checkName: function checkName(e, i) {
      var value = e.target.value;
      this.$set(this.optionArr[i], 'rename', value);

      this.$set(this.optionArr[i], 'error', value === '' || __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].hadSameFile(value) ? true : false);
    },
    rename: function rename() {
      var _this = this;

      if (this.passAll) {
        this.optionArr.forEach(function (v, i) {

          switch (v.selected) {
            case '重命名':
              __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].renameFileList[i].fileName = v.rename;
              __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].LoadFileList.push(__WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].renameFileList[i]);
              break;
            case '覆盖':
              __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].LoadFileList.push(__WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].renameFileList[i]);
              break;
            case '放弃加载':
              alert('不要了');
              break;
          }
        });

        __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].renameShow = false;

        __WEBPACK_IMPORTED_MODULE_0__bus_js__["a" /* default */].renameFileList = [];
        this.optionArr = [];
        return;
      }

      this.passAllErrorShow = true;

      setTimeout(function () {
        _this.passAllErrorShow = false;
      }, 5000);
    }
  },
  created: function created() {},

  components: {},
  watch: {
    renameFileList: function renameFileList() {
      this.initOptionArr();
    }
  }
};

/***/ }),

/***/ 48:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var htmlTemplate = "<!DOCTYPE html>\n<html lang=\"en\">\n<head>\n  <meta charset=\"UTF-8\">\n  <meta name=\"viewport\" content=\"width=device-width, initial-scale=1,maximum-scale=1, user-scalable=no\">\n  <title>Document</title>\n  <script>\n    var winWdith = window.innerWidth\n    if (winWdith < 320 || winWdith > 440) winWdith = 320\n    document.documentElement.style.fontSize = winWdith / 3.75 + 'px';\n    window.addEventListener('resize', function () {\n      winWdith = window.innerWidth\n      if (winWdith > 800) document.querySelector('.markdown-catalog').className = \"markdown-catalog catalog-hide\"\n      if (winWdith < 320 || winWdith > 440) return\n      document.documentElement.style.fontSize = winWdith / 3.75 + 'px';\n    })\n  </script>\n  <style>\n  body,html{width:100%;height:100%;margin:0;padding:0}body>#app{height:100%;overflow:hidden}.markdown2html .markdown-catalog li a{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.markdown2html{position:absolute;top:65px;bottom:10px;width:100%}.markdown2html .markdown-catalog{position:absolute;left:10px;border-top:5px solid #000;border-bottom:5px solid #000;overflow:auto;box-sizing:border-box;width:220px;height:100%;padding:1em .6em}.markdown2html .med-line{position:absolute;height:100%;width:5px;margin-left:240px;background:#000}.markdown2html .markdown-html{position:relative;overflow:auto;box-sizing:border-box;height:100%;padding:10px;margin-left:255px;margin-right:10px;border-top:5px solid #000;border-bottom:5px solid #000}blockquote,body,button,code,dd,div,dl,dt,fieldset,form,h1,h2,h3,h4,h5,h6,input,legend,li,ol,p,pre,td,textarea,th,ul{margin:0;padding:0}a{text-decoration:none;outline:0;cursor:pointer}input,textarea{spellcheck:false}.clearfix:after{content:\".\";display:block;height:0;clear:both;visibility:hidden}.clearfix{*zoom:1}@media(max-width:800px){table{width:100%}.warn{color:orange}div.markdown-header{padding-left:30px;margin:0}div.markdown-header a.catalog-btn{display:block}div.markdown-header div.document-info{line-height:1em;bottom:1px}div.markdown-header div.document-info .info-key,div.markdown-header div.document-info .info-value a{font-size:14px}div.markdown2html{bottom:0}div.markdown2html .markdown-catalog{transition:transform .5s}div.markdown2html .catalog-hide{transform:translateX(-220px)}div.markdown2html .catalog-show{transform:translateX(0)}div.markdown2html .med-line{display:none}div.markdown2html .markdown-html{margin:0}div.markdown2html .markdown-catalog{z-index:1;background:rgba(0,0,0,.8);left:0;border:0}div.markdown2html .markdown-catalog a{color:#ccc}div.markdown2html .markdown-catalog a:hover{color:#fff}}@media screen and (max-width:440px){div.markdown-header{margin:0;padding-left:.42456rem;height:.51rem}div.markdown-header .catalog-btn{position:absolute;left:.4em;line-height:.51rem;font-size:.183rem}div.markdown-header .made-by{top:auto;bottom:-.24rem}div.markdown-header .document-title,div.markdown-header .title-icon{font-size:.21228rem;line-height:.306rem;padding-left:0}div.markdown-header .document-header.noFileInfo .document-title{font-size:.24625rem;line-height:.51rem}div.markdown-header div.document-info{position:static;text-align:left;line-height:.11724rem}div.markdown-header div.document-info .info-key,div.markdown-header div.document-info .info-value a{font-size:.11724rem}div.markdown2html{top:.5525rem}div.markdown2html .markdown-html{border-bottom:0 solid}div.markdown2html .markdown-catalog{border:0}div.markdown2html .markdown-html{margin:0}div.markdown2html .markdown-html h1 a.title{font-size:26px}div.markdown2html .markdown-html h2 a.title{font-size:22px}div.markdown2html .markdown-html h3 a.title{font-size:19px}div.markdown2html .markdown-html h4 a.title{font-size:16px}div.markdown2html .markdown-html h5 a.title{font-size:14px}}body{min-width:320px}.iconfont{color:#303030;font-size:19.2px}a,body{color:#303030;font-size:16px;font-family:Verdana,Arial,Helvetica,sans-serif}.catalog-active{color:#e32020!important}.markdown-catalog li{list-style:none}.markdown-catalog .level1{font-size:16px;font-weight:700}.markdown-catalog .level2{font-size:14.4px;font-weight:700;margin-left:.8em}.markdown-catalog .level3{font-size:12.8px;margin-left:1.6em}.title{display:block;padding:.4em 0}.markdown-html>*{margin-bottom:1em}.markdown-html h1 a.title,.markdown-html h2 a.title{border-bottom:1px solid #ccc}.markdown-html h1 a.title{font-size:30px}.markdown-html h2 a.title{font-size:26px}.markdown-html h3 a.title{font-size:22px}.markdown-html h4 a.title{font-size:19px}.markdown-html h5 a.title{font-size:16px}.markdown-html p{font-size:16px;margin:.4em 0}.markdown-html ol,.markdown-html ul{margin-left:2em}.markdown-html ol ol,.markdown-html ol ul,.markdown-html ul ol,.markdown-html ul ul{margin:.5em 0 .5em 1.5em}.markdown-html ol .s-list-title,.markdown-html ul .s-list-title{font-size:19px;font-weight:700;padding:.2em 0}.markdown-html ol ol li,.markdown-html ol ul li,.markdown-html ul ol li,.markdown-html ul ul li{font-size:14px}.markdown-html ol ol .s-list-title,.markdown-html ol ul .s-list-title,.markdown-html ul ol .s-list-title,.markdown-html ul ul .s-list-title{font-size:16px;font-weight:700;padding:.2em 0}.markdown-html ol>li,.markdown-html ul>li{margin:.4em 0}.markdown-html table{border-collapse:collapse;border:1px solid #969696}.markdown-html table caption{font-size:19px;padding:.4em 0;font-weight:700}.markdown-html table td,.markdown-html table th{padding:.4em 1em;text-align:center;border:1px solid #969696}.markdown-html table thead th{color:#000;font-weight:700}.markdown-html table tbody tr{color:#303030}.markdown-html table tbody tr:nth-child(odd){background:#e2e2e2}.markdown-html blockquote{border-left:.4em solid #e2e2e2;padding-left:1em}.markdown-html blockquote p{text-indent:0}\n.markdown-html pre{margin-top:1em;margin-bottom:1em}.markdown-header{position:relative;height:60px;border-top:5px solid #000;margin:0 10px}.markdown-header .catalog-btn{position:absolute;top:.9em;left:.4em;display:none;width:1em;height:.2em;padding:.2em 0;border-top:.2em solid #000;border-bottom:.2em solid #000;background:#000;background-clip:content-box;font-size:22px}.markdown-header .made-by{position:absolute;z-index:2;right:.2em;top:.2em;background:#000;padding:0 .2em;border-radius:2px;color:#fff;font-size:12px}.markdown-header .document-title,.markdown-header .title-icon{display:inline-block;font-size:30px;line-height:60px;vertical-align:middle}.markdown-header .document-title{padding:0 .4em}.markdown-header .document-info{position:absolute;right:0;bottom:.2em;min-width:300px;text-align:right}.markdown-header .document-info span.info-key{font-weight:700}.markdown-header .document-info>*{display:inline-block;padding-right:.8em;margin:0}\n  </style>\n  <style>\n    .hljs{display:block;overflow-x:auto;padding:.5em;background:#2b2b2b}.hljs{color:#bababa}.hljs-strong,.hljs-emphasis{color:#a8a8a2}.hljs-bullet,.hljs-quote,.hljs-link,.hljs-number,.hljs-regexp,.hljs-literal{color:#6896ba}.hljs-code,.hljs-selector-class{color:#a6e22e}.hljs-emphasis{font-style:italic}.hljs-keyword,.hljs-selector-tag,.hljs-section,.hljs-attribute,.hljs-name,.hljs-variable{color:#cb7832}.hljs-params{color:#b9b9b9}.hljs-string{color:#6a8759}.hljs-subst,.hljs-type,.hljs-built_in,.hljs-builtin-name,.hljs-symbol,.hljs-selector-id,.hljs-selector-attr,.hljs-selector-pseudo,.hljs-template-tag,.hljs-template-variable,.hljs-addition{color:#e0c46c}.hljs-comment,.hljs-deletion,.hljs-meta{color:#7f7f7f}\n  </style>\n\n</head>\n\n<body>\n  \u8FD9\u91CC\u6CE8\u5165html\u7684\u4F4D\u7F6E\n  <script>\n    (function(){var ScrollResponse=function(options){var contextEl=options.context?document.querySelector(options.contextSel):document;this.options=options;this.catalogScrollEl=contextEl.querySelector(options.catalogSel||\".catalog\");this.contentScrollEl=contextEl.querySelector(options.contentSel||\".content\");this.catalogTitleEls=this.catalogScrollEl.querySelectorAll(options.title||\".title\");this.contentTitleEls=this.contentScrollEl.querySelectorAll(options.title||\".title\");this.prevActiveIndex=0;this.titlesTopArr=[];this.init()};window.ScrollResponse=ScrollResponse;ScrollResponse.prototype={construtor:ScrollResponse,init:function(){var _this=this;this.initTitlesTopArr(_this);if(this.options.resize){window.addEventListener(\"resize\",function(){_this.initTitlesTopArr(_this)})}this.initFirstTitle(this);this.contentScrollEl.addEventListener(\"scroll\",function(e){_this.responseActiveCatalog(e,_this);_this.catalogCovered(e,_this)})},initTitlesTopArr:function(_this){_this.titlesTopArr=[];_this.contentTitleEls=_this.contentScrollEl.querySelectorAll(_this.options.title||\".title\");if(_this.contentTitleEls.length===0){return}for(var i=1;i<_this.contentTitleEls.length;i++){_this.titlesTopArr.push(_this.contentTitleEls[i].offsetTop)}_this.titlesTopArr.push(_this.contentScrollEl.scrollHeight)},initFirstTitle:function(){this._addClass(this.catalogTitleEls[0],\"catalog-active\");if(this.options.contentTitleActive!==\"off\"){this._addClass(this.contentTitleEls[0],\"catalog-active\")}},responseActiveCatalog:function(e,_this){var sTop=e.target.scrollTop;for(var i=0;i<_this.titlesTopArr.length;i++){if(sTop<_this.titlesTopArr[i]){if(i!==_this.prevActiveIndex){_this._addClass(_this.catalogTitleEls[i],\"catalog-active\");_this._removeClass(_this.catalogTitleEls[_this.prevActiveIndex],\"catalog-active\");if(_this.options.contentTitleActive!==\"off\"){_this._addClass(_this.contentTitleEls[i],\"catalog-active\");_this._removeClass(_this.contentTitleEls[_this.prevActiveIndex],\"catalog-active\")}_this.prevActiveIndex=i}break}}},catalogCovered:function(e,_this){var activeCatalog=_this.catalogScrollEl.getElementsByClassName(\"catalog-active\")[0];if(activeCatalog.offsetTop+activeCatalog.offsetHeight>=(_this.catalogScrollEl.scrollTop+_this.catalogScrollEl.clientHeight)){_this.catalogScrollEl.scrollTop=activeCatalog.offsetTop}else{if(activeCatalog.offsetTop<_this.catalogScrollEl.scrollTop){_this.catalogScrollEl.scrollTop=activeCatalog.offsetTop-_this.catalogScrollEl.offsetHeight+activeCatalog.offsetHeight*2}}},_removeClass:function(el,className){el.className=el.className.replace(className,\"\")},_addClass:function(el,className){el.className+=(\" \"+className)}}})();\n  </script>\n  <script>\n    new ScrollResponse({contentSel:\".markdown-html\",catalogSel:\".markdown-catalog\",resize:true});var catalogBtnEl=document.querySelector(\".catalog-btn\");var catalogEl=document.querySelector(\".markdown-catalog\");catalogBtnEl.onclick=function(){var className=catalogEl.className;if(className.indexOf(\"hide\")!=-1){catalogEl.className=className.replace(\"hide\",\"show\")}else{if((className.indexOf(\"show\")!=-1)){catalogEl.className=className.replace(\"show\",\"hide\")}}};\n  </script>\n</body>\n</html>";

/* harmony default export */ __webpack_exports__["a"] = htmlTemplate;

/***/ }),

/***/ 49:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);


window.i = 0;
window.I = function () {
  window.i++;
  return window.i + '.';
};

window.RE = function (observerData) {
  return JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(observerData));
};

window.log = function (dataInfo, dataKey, _this) {

  console.log('%c ' + window.I() + dataInfo + '【初始化】', 'color:red;font-size:14px;', '\n', dataKey + ':', window.RE(_this[dataKey]), '\n', '\u4F4D\u7F6E\uFF1A[' + _this.$options.name + ']');
};

window.eLog = function (optionInfo, _this) {
  console.log('%c ' + window.I() + optionInfo + ' \u2193' + '【操作】', 'color:blue;font-size:14px;', '\n', '\u4F4D\u7F6E\uFF1A[' + _this.$options.name + ']');
};

window.vLog = function (validateInfo, condition, _this) {
  var vResult = condition ? true : false;
  console.log('%c ' + window.I() + '\u3010\u9A8C\u8BC1\u3011 ' + validateInfo + ' -> ', 'color:orange;font-size:14px;', vResult, '\n', '\u4F4D\u7F6E\uFF1A[' + _this.$options.name + ']');
};

window.wLog = function (dataKey, _arguments, _this) {
  var newV = _arguments[0] ? window.RE(_arguments[0]) : '';
  var oldV = _arguments[1] ? window.RE(_arguments[1]) : '';
  console.log('%c ' + window.I() + '\u3010watch\u3011 ' + dataKey + ' \u3010\u53D1\u751F\u53D8\u52A8\u3011', 'color:green;font-size:14px;', '\n', '新值', newV, '\n', '旧值', oldV, '\n', '\u4F4D\u7F6E\uFF1A[' + _this.$options.name + ']');
};

/***/ }),

/***/ 87:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 88:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 89:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 90:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 91:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 92:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 93:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[286]);


// WEBPACK FOOTER //
// static/js/app.d647b95103e63ce3c18a.js